import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'plain-modal',
    templateUrl: './plain-modal.component.html',
    styleUrls: ['./plain-modal.component.scss'],
    standalone: false
})
export class PlainModalComponent implements OnInit {
  @Input() title: string = 'Modal Title'
  @Input() message: string = ''
  @Input() visible: boolean = true;

  constructor() {
    //
  }

  ngOnInit() {
    //
  }

}
